/* PRISKEL · lx2 — header niceties, search best sellers, last-piece wording */
(function(){
  var d=document;
  function $(s,r){return (r||d).querySelector(s)}function $$(s,r){return [].slice.call((r||d).querySelectorAll(s))}
  /* header: hide zero counts, mark signed-in */
  function counts(){
    $$('#pk-hd [data-pk-cart-count]').forEach(function(c){var z=(c.textContent||'').trim()==='0'||(c.textContent||'').trim()==='';var b=c.closest('.pk-hd__bag');if(b)b.classList.toggle('is-empty',z);});
    var a=$('#pk-hd [data-pk-acct-open].pk-hd__d');if(a&&/^\s*hi\b/i.test(a.textContent||''))a.classList.add('is-in');
  }
  function watchCounts(){counts();$$('#pk-hd [data-pk-cart-count]').forEach(function(c){new MutationObserver(counts).observe(c,{childList:true,characterData:true,subtree:true})});d.addEventListener('cart:count:update',function(){setTimeout(counts,50)});}
  /* search: four best sellers under the categories, fetched once */
  var bestDone=false;
  function best(){
    if(bestDone)return;var idle=$('#pk-search [data-pk-sx-idle]');if(!idle)return;bestDone=true;
    fetch('/collections/best-sellers-jewellery-india/products.json?limit=4').then(function(r){return r.json()}).then(function(j){
      if(!j||!j.products||!j.products.length)return;
      var inr=function(p){var n=Math.round(parseFloat(p));return '₹'+n.toLocaleString('en-IN')};
      var h='<div class="lx2-sx-best"><p class="pk-hd__ey">Most loved right now</p><ul>';
      j.products.slice(0,4).forEach(function(p){var im=p.images&&p.images[0]?p.images[0].src:'';var v=p.variants&&p.variants[0];var t=(p.title||'').replace(/ for (Women|Men)$/i,'');
        h+='<li><a href="/products/'+p.handle+'">'+(im?'<img src="'+im+(im.indexOf('?')>-1?'&':'?')+'width=160" alt="" loading="lazy" width="64" height="80">':'<i></i>')+'<span style="margin:0"><b>'+t.replace(/</g,'&lt;')+'</b><span>'+(v?inr(v.price):'')+'</span></span></a></li>'});
      idle.insertAdjacentHTML('beforeend',h+'</ul></div>');
    }).catch(function(){});
  }
  d.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('[data-pk-search-open]'))setTimeout(best,60)},true);
  /* product page: "Only 1 left" becomes "The last piece" */
  function last(root){$$('.pk-pd__av.is-low',root).forEach(function(x){var b=$('p b',x);if(b&&/^Only 1 left$/.test(b.textContent.trim())){b.textContent='The last piece';x.classList.add('is-last');}})}
  function watchStock(){var s=$('[data-pkp-stock]');if(!s)return;last(s);new MutationObserver(function(){last(s)}).observe(s,{childList:true,subtree:true});}
  /* floating stack: keep the offer tab and back-to-top clear of the sticky bag bar and the WhatsApp button */
  function floats(){
    var root=d.documentElement,raf=0;
    function upd(){raf=0;
      var sk=$('.pk-pd__sticky.is-on'),h=sk?Math.max(0,Math.round(innerHeight-sk.offsetTop)):0;
      root.style.setProperty('--pk-sk-h',h+'px');
      var wa=$('.pz3-floating-icon'),b=0;
      if(wa){var w=wa.getBoundingClientRect();if(w.height&&w.top<innerHeight)b=Math.round(innerHeight-w.top+10);}
      if(h)b=Math.max(b,h+12);
      if(b)root.style.setProperty('--pk-bt-b',b+'px');else root.style.removeProperty('--pk-bt-b');
    }
    function q(){if(!raf)raf=requestAnimationFrame(upd)}
    addEventListener('scroll',q,{passive:true});addEventListener('resize',q);
    new MutationObserver(q).observe(d.body,{attributes:true,attributeFilter:['class']});
    setInterval(q,1200);q();
  }
  /* sticky header guard: if an app or stylesheet turns the page into a scroll container and breaks position:sticky,
     fall back to a fixed header with a placeholder so the layout never jumps */
  function stickyGuard(){
    var hd=d.getElementById('pk-hd');if(!hd)return;var w=hd.closest('.shopify-section')||hd.parentElement;if(!w||!w.parentNode)return;
    var root=d.documentElement,ph=d.createElement('div'),fixed=false,raf=0;
    ph.className='pk-hd-ph';ph.setAttribute('aria-hidden','true');ph.style.display='none';w.parentNode.insertBefore(ph,w);
    function ann(){return parseFloat(getComputedStyle(root).getPropertyValue('--pk-ann-h'))||0}
    function chk(){raf=0;var y=scrollY||root.scrollTop||0;
      if(!fixed){var r=w.getBoundingClientRect();
        if(y>ann()+40&&r.bottom<=1){fixed=true;ph.style.display='block';root.classList.add('pk-hd-fixed');}
      }
      if(fixed){var a=ann();root.style.setProperty('--pk-hd-top',(-Math.min(y,a))+'px');if(y<130)ph.style.height=w.offsetHeight+'px';}
    }
    function q(){if(!raf)raf=requestAnimationFrame(chk)}
    addEventListener('scroll',q,{passive:true});addEventListener('resize',q);
  }
  function boot(){watchCounts();watchStock();floats();stickyGuard();}
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',boot);else boot();
})();
